import { FetchWrapper } from "../_models/types";
const api = `${process.env.REACT_APP_API_URL}/v1/profile/`;

const getUserProfile = async (user_id: string, fetchWrapper: FetchWrapper) => fetchWrapper.get(`${api}profile/${user_id}/`);

export const profileService = {
    getUserProfile
}
